import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { selectRow, unselectTotalVulns } from 'store/Manage/actions';
import SelectionCell from 'shared/ui/Table/cells/SelectionCell';
import { selectShowQuickPlanner, selectVulnsSelected } from 'store/Manage/selectors';
import { ReactComponent as Drag } from 'Images/drag.svg';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import itemTypes from 'Common/Components/DragAndDrop/ItemTypes';
import Skeleton from 'Common/Components/Skeleton';
import { sameVulnId } from 'Common/Functions/vulnerabilityId';

const DragHandle = styled.div`
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  svg {
    cursor: grab;
  }

  &:active svg {
    cursor: grabbing;
  }
`;
DragHandle.displayName = 'DragHandle';

const CheckColum = ({ vuln, showSkeleton }) => {
  const vulnsSelected = useSelector((state) => selectVulnsSelected(state));
  const dispatch = useDispatch();
  const isSelected = vulnsSelected.find((vulnSelected) => sameVulnId(vulnSelected, vuln));
  const handleClick = (e) => {
    dispatch(unselectTotalVulns());
    dispatch(selectRow(e, vuln));
  };

  if (showSkeleton) return <Skeleton />;
  return (
    <div title="Select">
      <SelectionCell checked={ !!isSelected } onChange={ handleClick } />
    </div>
  );
};

export const DraggableCheckColum = ({ vuln, showSkeleton }) => { // eslint-disable-line import/prefer-default-export
  const isQuickPlannerOpen = useSelector(selectShowQuickPlanner);

  const [, drag, preview] = useDrag(() => ({
    type: itemTypes.VULN,
    item: vuln,
    collect: () => ({
      canDrag: isQuickPlannerOpen
    }),
    canDrag: isQuickPlannerOpen
  }), [vuln, isQuickPlannerOpen]);

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isQuickPlannerOpen) return <DragHandle ref={ drag }><Drag /></DragHandle>;
  return <CheckColum vuln={ vuln } showSkeleton={ showSkeleton } />;
};
